import { Card, Table } from "@arco-design/web-react"
import { GLAPI } from "@/apis/accounting";
import { useSearchParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { Currency } from "@/components/Numeric";
import { EnumLabel } from "@/components/Enum";
import { GLImpactTypeDef } from "@/enums/common";

export const GL = () => {
    const [params] = useSearchParams();
    const [queryParams] = useState({
        type: params.get("type"),
        from: params.get("from")
    })

    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);

    const getGLList = useCallback(async () => {
        const values = await GLAPI.query(page, queryParams);
        setData(values.records);
        setTotal(values.total);
    }, [page, queryParams]);

    useEffect(() => {
        getGLList();
    }, [getGLList])

    return (
        <Card title="Journal Entries">
            <Table rowKey="id" columns={[
                { title: "Account", dataIndex: "accountName" },
                { title: "Action", render: (col, record) => <EnumLabel enumObj={GLImpactTypeDef} value={record.action} /> },
                { title: "Amount", render: (col, record) => <span>${record.itemName}: <Currency value={record.totalAmount} /></span> },
                { title: "Create Time", dataIndex: "createTime" }
            ]}
                data={data} pagination={{ total, current: page, pageSize: 20 }} onChange={(pagination) => setPage(pagination.current)}
            />
        </Card>
    )
}